import T from '../i18n/content.js';
import { useLang } from '../i18n/LangContext.jsx';

export default function Ticker() {
  const { lang } = useLang();
  const items = T.ticker[lang] || T.ticker.en;
  // Tripled so the marquee animation can scroll -50% without revealing the seam.
  const all = [...items, ...items, ...items];
  const isCn = lang === 'cn';

  return (
    <div className="ticker">
      <div className="ticker__track">
        {all.map((tx, i) => (
          <span key={i}>
            <span className="dot" />
            <span className={isCn ? 'cn' : ''}>{tx}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
